import React, { Component } from 'react';
import '../styles/about.css';
import kitty from '../img/kitty_mug_shot.jpg';

class AboutPage extends Component {
  render() {
    return (
      <div className="aboutContainer">
        <div className="content">
          <div className="photo">
            <img src={kitty} alt="Kitty Tuttle" />
          </div>
          <div className="text">
            <h2>LET ME INTRODUCE MYSELF</h2>
            <h3>
              I’m Kitty Tuttle, owner and founder of Kitty Tuttle Interiors
            </h3>
            <p>
              Many years ago, I earned a bachelors degree in art and economics
              from Agnes Scott College in Decatur, Georgia. Soon after I
              graduated, I discovered my true calling and earned an interior
              design degree. After nine years of experience at large design
              firms, I opened the doors of Kitty Tuttle Interiors in 1997.
            </p>
            <p>
              As a professional member of ASID with over 30 years of interior
              design experience, my clients see me as an expert of color,
              composition and space planning. I pride myself on creating design
              solutions that not only improve the beauty and functionality of a
              home, but also reflect the personalities and unique stories of my
              clients.
            </p>
            <p>
              When I’m not busy running my own business, I enjoy singing in my
              church’s choir, scouring flea markets for antiques and exploring
              other cultures while traveling with my family.
            </p>
            <p style={{ textAlign: 'center', color: '#fff' }}>~~~</p>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/containers/about.js